module.exports = __webpack_public_path__ + "static/catWalkCycle-bb6627f6f7ba0712dc30acbacfd7b3d6.png";